var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"loader-overlay"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-balls"},[_c('div',{staticClass:"ball delay-1"}),_c('div',{staticClass:"ball delay-2"}),_c('div',{staticClass:"ball delay-3"})])
}]

export { render, staticRenderFns }